(() => {
  'use strict';
  const root = document.getElementById('bundle-product');
  if (!root) return;
  const form = root.querySelector('#bundle-product-form');
  const groups = Array.from(form.querySelectorAll('.br-group'));
  const button = form.querySelector('#br-add');
  const message = form.querySelector('#br-message');
  const heroButton = root.querySelector('#br-hero-add');
  const heroMessage = root.querySelector('#br-hero-message');
  const presetButtons = Array.from(form.querySelectorAll('[data-br-preset]'));
  const presetMessage = form.querySelector('#br-preset-message');
  const money = n => (n / 100).toLocaleString('lt-LT', {style:'currency',currency:root.dataset.currency});
  let busy = false;
  function presetPlan(name) {
    if (form.querySelector('[data-missing]') || groups.some(group => group.dataset.fixed === 'true' && Array.from(group.querySelectorAll('.br-option')).some(option => Number(option.querySelector('.br-flavour').value) > 0 && option.dataset.available !== 'true'))) return null;
    const sprouty = 'batonelis-sprouty';
    const jegos = 'batonelis-jegos-maistas-su-anakardziais-ir-kokosu-35g';
    const bars = name === 'sprouty' ? [[sprouty, 12]] : name === 'jegos' ? [[jegos, 12]] : [[sprouty, 6], [jegos, 6]];
    const recipe = name === 'recommended' ? {
      energy: ['samangas-mangu-skonio-energerietis-100g', 'braskentas-braskiu-skonio-energerietis', 'vynuogenijus-vynuogiu-skonio-samangas-100g', 'meditakava-kakavos-skonio-energerietis-100g', 'bananindze-bananu-skonio-energerietis-100g', 'pina-coala-ananasu-skonio-energerietis-100g'].map(handle => [handle, 1]),
      crunch: [['samangas-liofilizuota-30g', 1], ['braskentas-liofilizuota-28g', 1]],
      sprouty: [[sprouty, 1], [jegos, 1]]
    } : { main: bars };
    if (!['recommended', 'sprouty', 'mixed-bars', 'jegos'].includes(name)) return null;
    const plan = new Map();
    for (const [id, choices] of Object.entries(recipe)) {
      const group = groups.find(group => group.dataset.group === id && group.dataset.fixed === 'false');
      if (!group || choices.reduce((sum, [, quantity]) => sum + quantity, 0) !== Number(group.dataset.target)) return null;
      const options = Array.from(group.querySelectorAll('.br-option'));
      for (const [handle] of choices) {
        if (!options.some(option => option.dataset.handle === handle && option.dataset.available === 'true')) return null;
      }
      options.forEach(option => plan.set(option.querySelector('.br-flavour'), choices.find(([handle]) => handle === option.dataset.handle)?.[1] || 0));
    }
    return plan;
  }
  function evaluate() {
    let valid = !form.querySelector('[data-missing]');
    let separate = 0;
    const summary = [];
    groups.forEach(group => {
      let count = 0;
      const target = Number(group.dataset.target);
      group.querySelectorAll('.br-option').forEach(option => {
        const input = option.querySelector('.br-flavour');
        const quantity = Number(input.value);
        const integer = Number.isInteger(quantity) && quantity >= 0 && quantity <= target;
        if (!integer) valid = false;
        if (integer && quantity > 0) {
          count += quantity;
          separate += quantity * Number(option.dataset.price);
          summary.push(`${quantity} × ${option.dataset.title}`);
          if (option.dataset.available !== 'true') valid = false;
        }
        if (input.type === 'number') input.setCustomValidity(integer ? '' : 'Įvesk sveiką, neneigiamą kiekį rinkinio ribose.');
      });
      if (count !== target) valid = false;
      group.querySelector('.br-progress').textContent = `${group.dataset.fixed === 'true' ? 'Fiksuota sudėtis' : 'Pasirinkta'}: ${count} / ${target}`;
      const track = group.querySelector('.br-progress-track');
      if (track) {
        track.setAttribute('aria-valuenow', String(count));
        track.querySelector('span').style.width = `${Math.min(count / target, 1) * 100}%`;
      }
      group.querySelectorAll('.br-option').forEach(option => {
        const quantity = Number(option.querySelector('.br-flavour').value);
        const output = option.querySelector('.br-qty-value');
        if (output) output.textContent = String(quantity);
        option.classList.toggle('br-selected', quantity > 0);
        option.querySelectorAll('[data-br-change]').forEach(control => {
          control.disabled = busy || (Number(control.dataset.brChange) > 0
            ? count >= target || option.dataset.available !== 'true'
            : quantity <= 0);
        });
      });
    });
    if (root.dataset.mystery !== 'true') form.querySelector('#br-summary').textContent = summary.length ? summary.join('; ') : 'Pasirink skonių kiekius aukščiau.';
    const saving = root.querySelector('#br-saving');
    const difference = separate - Number(root.dataset.price);
    saving.hidden = !valid || difference <= 0 || root.dataset.mystery === 'true';
    if (!saving.hidden) saving.textContent = `Atskirai: ${money(separate)}. Su rinkiniu sutaupai ${money(difference)}.`;
    const available = root.dataset.available === 'true';
    button.disabled = busy || !available || !valid;
    button.textContent = busy ? 'Pridedama…' : !available ? 'Išparduota' : valid ? 'Į krepšelį →' : 'Užbaik rinkinio pasirinkimą';
    if (heroButton) {heroButton.disabled = button.disabled;heroButton.textContent = button.textContent;}
    if (heroMessage) heroMessage.textContent = message.textContent;
    presetButtons.forEach(control => {
      const plan = presetPlan(control.dataset.brPreset);
      control.disabled = busy || !plan;
      control.setAttribute('aria-pressed', String(Boolean(plan && Array.from(plan).every(([input, quantity]) => Number(input.value) === quantity))));
    });
    return valid && available;
  }
  form.addEventListener('input', () => {message.textContent='';if (presetMessage) presetMessage.textContent='';evaluate();});
  form.addEventListener('click', event => {
    const preset = event.target.closest('[data-br-preset]');
    if (preset) {
      if (preset.disabled || busy) return;
      const plan = presetPlan(preset.dataset.brPreset);
      if (!plan) return;
      plan.forEach((quantity, input) => {input.value = String(quantity);});
      message.textContent = '';
      evaluate();
      if (presetMessage) presetMessage.textContent = 'Sudėtis užpildyta. Kiekius gali koreguoti žemiau.';
      return;
    }
    const control = event.target.closest('[data-br-change]');
    if (!control || control.disabled || busy) return;
    const group = control.closest('.br-group');
    const input = control.closest('.br-option').querySelector('.br-flavour');
    const count = Array.from(group.querySelectorAll('.br-flavour')).reduce((sum, field) => sum + Number(field.value), 0);
    const change = Number(control.dataset.brChange);
    if (change > 0 && count >= Number(group.dataset.target)) return;
    input.value = String(Math.max(0, Number(input.value) + change));
    message.textContent = '';
    if (presetMessage) presetMessage.textContent = '';
    evaluate();
  });
  // Capture only this form so the shared cart handler cannot bypass bundle validation.
  form.addEventListener('submit', async event => {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy || !evaluate() || !form.reportValidity()) return;
    const data = new FormData(form);
    // Zero quantities are omitted; each selected flavour remains an order line property.
    form.querySelectorAll('.br-flavour').forEach(input => {if (Number(input.value) === 0) data.delete(input.name);});
    busy = true;evaluate();message.textContent='';
    try {
      const response = await fetch(form.action.replace(/\/?$/, '.js'), {method:'POST',body:data,headers:{Accept:'application/json'}});
      const result = await response.json();
      if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'Nepavyko pridėti rinkinio. Patikrink prieinamumą ir bandyk dar kartą.');
      message.textContent='Rinkinys pridėtas į krepšelį.';
      if (window.TyraCart && typeof window.TyraCart.open === 'function') window.TyraCart.open();
      else window.location.assign(form.action.replace(/\/add\/?$/, ''));
    } catch (error) {message.textContent=error.message || 'Ryšio klaida. Bandyk dar kartą.';}
    finally {busy=false;evaluate();}
  }, true);
  evaluate();
})();
